import { useEffect } from "react";

const SITE = "https://joetanis.com";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSeo({ title, description, path = "/", noindex = false }) {
  useEffect(() => {
    if (!title) return;
    document.title = title;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    setMeta("property", "og:title", title);
    setMeta("name", "twitter:title", title);
    setMeta("property", "og:url", SITE + path);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1");
    const canon = document.head.querySelector('link[rel="canonical"]');
    if (canon) canon.setAttribute("href", SITE + path);
  }, [title, description, path, noindex]);
}
